import {UiComponentBaseSchema, UiComponentSchema} from "./UiComponent";
import {z} from "zod";
import {LayoutContainerBaseSchema} from "./LayoutContainer";

export const GridSizeSchema = z.union([
    z.literal('auto'),
    z.literal('grow'),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
    z.literal(11),
    z.literal(12),
]);

export type GridSize = z.infer<typeof GridSizeSchema>;

export const GridPropertiesSchema = z.object({
    xs: GridSizeSchema.optional(),
    sm: GridSizeSchema.optional(),
    md: GridSizeSchema.optional(),
    lg: GridSizeSchema.optional(),
    xl: GridSizeSchema.optional(),
});

export type GridProperties = z.infer<typeof GridPropertiesSchema>;

export const GridItemSchema = UiComponentBaseSchema.extend({
    componentType: z.literal('GridItem'),
    gridProperties: GridPropertiesSchema,
    childComponents: z.array(z.lazy(() => UiComponentSchema)),
});

export type GridItem = z.infer<typeof GridItemSchema>;

export const GridLayoutContainerSchema = LayoutContainerBaseSchema.extend({
    componentType: z.literal('GridLayoutContainer'),
    items: z.array(GridItemSchema),
});

export type GridLayoutContainer = z.infer<typeof GridLayoutContainerSchema>;
